// tslint:disable:max-line-length
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../events/work-field-input-change-event';
import { E5coreUiWorkFieldTypeBase } from '../e5core-ui-work-field/e5core-ui-work-field-type-base';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-input',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-input-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-input-box>
    <e5core-ui-work-field-type-input-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-input-bootstrap>
    <e5core-ui-work-field-type-input-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-input-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeInputComponent extends E5coreUiWorkFieldTypeBase {

  @Input() pattern: string ;

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldInputChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, $event.value, $event.error);
    return ;
  }

}
